import { useApolloClient } from '@apollo/react-hooks';
import { useWhyDidYouUpdate } from '../../hooks';
import React, { useCallback, useState } from 'react';
import Snowfall from '../../components/common/snowfall';
import { userLoginByVat } from '../../graphql/db';
import { rootStore } from '../../store';
import LoginForm from './login-form';
import { useHistory, useLocation } from 'react-router-dom';
import { useHandleError } from '../../services';
import { toastWarning } from 'utils/toasts';

const LoginPage = () => {
  /*-------------------- Body -----------------------------------------------*/
  const client = useApolloClient();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>(null);
  const history = useHistory();
  const location = useLocation();

  //const { from } = location.state || { from: { pathname: '/' } };
  const state: any = location.state || { from: { pathname: '/' } };
  const from = state.from;
  const { handleGraphqlError } = useHandleError('LoginPage');

  /*! -------------------- Handlers -------------------------------------------*/
  /**
   * * 1. ΠΑΤΗΘΗΚΕ ΤΟ SUBMIT -> ΕΚΤΕΛΩ ΤΟ QUERY (Callback)
   */
  // const handleSubmit = useCallback(
  //   (values, actions) => {
  //     actions.setSubmitting(false);
  //     setLoading(true);

  //     userLoginByVat(client, values.vatNumber)
  //       .then((res) => {
  //         console.log('############ raw response:', res);

  //         const login = res?.data?.collectionpointLogin;
  //         console.log('############ extracted login data:', login);

  //         if (!login) {
  //           console.warn('No login data returned from server.');
  //           return;
  //         }

  //         if (res.data?.numberOfCollectionpoints > 1) {
  //           console.log('More than 1 CP');
  //           rootStore.appStore.setVatNumber(values.vatNumber);
  //           history.push('/loginpostal');
  //         } else if (res.data?.hasPendingApplicationForm) {
  //           setLoading(false);
  //           history.replace(from);
  //           toastWarning(
  //             'Υπάρχει εκκρεμής αίτηση νέου χρήστη με αυτά τα στοιχεία. Παρακαλώ επικοινωνήστε με τα γραφεία της ΑΦΗΣ.',
  //             20000,
  //           );
  //         } else {
  //           rootStore.appStore.login(login.collectionpointId, login);
  //           console.log('[LoginPage] successful login, pushing to:', from);
  //           setLoading(false);
  //           history.replace(from);
  //         }
  //       })
  //       .catch((err) => {
  //         handleGraphqlError('userLoginByVat-get', err, 'Σφάλμα Εισόδου.');
  //         setError(err);
  //       })
  //       .finally(() => {
  //         setLoading(false);
  //       });
  //   },
  //   [client, from, handleGraphqlError, history],
  // );

  /*-------------------- Render ---------------------------------------------*/
  useWhyDidYouUpdate('[LoginPage]', {});

  return (
    <div id="login-page">
      <Snowfall />
      <div className="d-flex align-items-center justify-content-center" style={{ height: '85vh' }}>
        <LoginForm onSubmit={() => {}} message={error} loading={loading} />
      </div>
    </div>
  );
};

export default LoginPage;
LoginPage.whyDidYouRender = true;
